<app-general-search-input
  [title]="'SEARCH.SEARCH_BAR.TITLE.PRICE' | translate"
  [expanded]="group.get('min')?.value || group.get('max')?.value"
>
  <ng-template>
    <form [formGroup]="group" class="easy-form price-form">
      <div class="price-limit-container">
        <mat-form-field class="price-field">
          <app-easy-input
            class="price-select-field"
            formControlName="min"
            [placeholder]="'min'"
            [type]="'number'"
            min="0"
            [outerSuffixLabel]="'Ft'"
            (ngModelChange)="valueChanged($event, 'min')"
          ></app-easy-input>
        </mat-form-field>

        <span class="currency-container"> - </span>

        <mat-form-field class="price-field">
          <app-easy-input
            class="price-select-field"
            formControlName="max"
            [placeholder]="'max'"
            [type]="'number'"
            min="0"
            [outerSuffixLabel]="'Ft'"
            (ngModelChange)="valueChanged($event, 'max')"
          ></app-easy-input>
        </mat-form-field>
      </div>
    </form>
  </ng-template>
</app-general-search-input>
